import React from "react";
import PropTypes from "prop-types";
import KpisEstruturaisDesktop from "./KpisEstruturaisDesktop";

function KpisEstruturais({ app, config }) {
  return <KpisEstruturaisDesktop app={app} config={config} />;
}

KpisEstruturais.defaultProps = {
  app: null,
  config: {},
};

KpisEstruturais.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
};

export default KpisEstruturais;
